"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PureAnnotationToolbar = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));

var _Popover = _interopRequireDefault(require("@react/react-spectrum/Popover"));

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button/js/Button"));

var _Icon = _interopRequireDefault(require("@react/react-spectrum/Icon"));

var _PinOff = _interopRequireDefault(require("@react/react-spectrum/Icon/PinOff"));

var _TextStrikethrough = _interopRequireDefault(require("@react/react-spectrum/Icon/TextStrikethrough"));

var _Draw = _interopRequireDefault(require("@react/react-spectrum/Icon/Draw"));

var _TooltipButton = _interopRequireDefault(require("../components/TooltipButton"));

var _svgs = require("../lib/svgs");

var _AnnotationToolbar = _interopRequireDefault(require("../style/AnnotationToolbar.scss"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * AnnotationToolbar component
 * @param {object} props - properties of component
 * @returns {ReactElement} React elemn
 */
var AnnotationToolbar = /*#__PURE__*/function (_React$Component) {
  _inherits(AnnotationToolbar, _React$Component);

  var _super = _createSuper(AnnotationToolbar);

  /**
   * Constructor for AnnotationsToolbar
   * @param {object} props - props sent to the component
   * @returns {undefined}
   */
  function AnnotationToolbar(props) {
    var _this;

    _classCallCheck(this, AnnotationToolbar);

    _this = _super.call(this, props);
    _this.state = {
      calculatePosition: true
    };
    _this.handleOverlayTriggerRef = _this.handleOverlayTriggerRef.bind(_assertThisInitialized(_this));
    _this.handleColorSelection = _this.handleColorSelection.bind(_assertThisInitialized(_this));
    _this.handleOverlayShow = _this.handleOverlayShow.bind(_assertThisInitialized(_this));
    _this.handleComponentRef = _this.handleComponentRef.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Function to assign a reference to the element that represents the component
   * @param {element} ref - reference
   * @returns {undefined}
   */


  _createClass(AnnotationToolbar, [{
    key: "handleComponentRef",
    value: function handleComponentRef(ref) {
      this.componentRef = ref;
    }
    /**
     * Function to assign a reference to the element that represents the overlay trigger
     * @param {element} ref - reference
     * @returns {undefined}
     */

  }, {
    key: "handleOverlayTriggerRef",
    value: function handleOverlayTriggerRef(ref) {
      this.overlayTriggerRef = ref;
    }
    /**
     * Lifecycle method for when a component has been updated
     * @param {object} previousProps - previous version of the props
     * @returns {undefined}
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps) {
      var annotationTypes = this.props.annotationTypes;
      var needsUpdatePosition = !(0, _lodash.default)(annotationTypes, previousProps.annotationTypes);

      if (needsUpdatePosition) {
        this.setState({
          calculatePosition: true
        });
      }
    }
    /**
     * Function to handle positioning overlay
     * @returns {undefined}
     */

  }, {
    key: "handleOverlayShow",
    value: function handleOverlayShow() {
      var _this2 = this;

      requestAnimationFrame(function () {
        var calculatePosition = _this2.state.calculatePosition;
        var overlayElement = document.getElementById(_this2.overlayTriggerRef.overlayId);

        if (overlayElement && calculatePosition) {
          var componentElementRect = _this2.componentRef.getBoundingClientRect();

          var componentPosition = componentElementRect.left + componentElementRect.width;
          var overlayElementRect = overlayElement.getBoundingClientRect();
          var overlayPosition = overlayElementRect.left + overlayElementRect.width;
          var newState = {
            calculatePosition: false
          };
          var cb;

          if (overlayPosition > componentPosition) {
            newState.overlayOffset = componentPosition - overlayPosition;

            cb = function cb() {
              _this2.overlayTriggerRef.hide();

              requestAnimationFrame(function () {
                return _this2.overlayTriggerRef.show();
              });
            };
          } else {
            newState.overlayOffset = undefined;
          }

          _this2.setState(newState, cb);
        }
      });
    }
    /**
     * Function to handle clicking of a color button
     * @param {string} color - hex value of selected color
     * @returns {undefined}
     */

  }, {
    key: "handleColorSelection",
    value: function handleColorSelection(color) {
      var saveAnnotationColor = this.props.saveAnnotationColor;
      this.overlayTriggerRef.hide();
      saveAnnotationColor(color);
    }
    /**
     * Lifecycle method for rendering
     * @returns {ReactElement} markup
     */

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          annotationColor = _this$props.annotationColor,
          annotationTypes = _this$props.annotationTypes,
          intl = _this$props.intl,
          isAnnotating = _this$props.isAnnotating,
          disabled = _this$props.disabled,
          onAnnotationClick = _this$props.onAnnotationClick,
          newAnnotationType = _this$props.newAnnotationType,
          touchControls = _this$props.touchControls,
          compactLayout = _this$props.compactLayout;
      var overlayOffset = this.state.overlayOffset;
      var icons = [];

      if (annotationTypes.pin === true) {
        var pinSelected = newAnnotationType === 'pin';
        var label = intl.formatMessage({
          id: 'comments.textarea_input.pin.tooltip'
        });
        icons.push( /*#__PURE__*/_react.default.createElement("div", {
          className: "annotation-tool-wrapper",
          key: "pin-tool"
        }, touchControls ? /*#__PURE__*/_react.default.createElement(_Button.default, {
          "aria-label": label,
          "data-annotation-button": true,
          "data-test": "pin-button",
          variant: "tool",
          selected: isAnnotating && pinSelected,
          disabled: disabled || isAnnotating && !pinSelected,
          icon: /*#__PURE__*/_react.default.createElement(_PinOff.default, null),
          onMouseDown: compactLayout ? undefined : function (event) {
            return onAnnotationClick(event, 'pin');
          },
          onClick: compactLayout ? function (event) {
            return onAnnotationClick(event, 'pin');
          } : undefined
        }) : /*#__PURE__*/_react.default.createElement(_TooltipButton.default, {
          "aria-label": label,
          placement: "bottom",
          "data-annotation-button": true,
          "data-test": "pin-button",
          selected: isAnnotating && pinSelected,
          disabled: disabled || isAnnotating && !pinSelected,
          icon: /*#__PURE__*/_react.default.createElement(_PinOff.default, null),
          tooltip: label,
          onClick: function onClick(event) {
            return onAnnotationClick(event, 'pin');
          }
        })));
      }

      if (annotationTypes.highlight === true) {
        var highlightSelected = newAnnotationType === 'highlight';

        var _label = intl.formatMessage({
          id: 'comments.textarea_input.highlight.tooltip'
        });

        icons.push( /*#__PURE__*/_react.default.createElement("div", {
          className: "annotation-tool-wrapper",
          key: "highlight-tool"
        }, touchControls ? /*#__PURE__*/_react.default.createElement(_Button.default, {
          "aria-label": _label,
          "data-annotation-button": true,
          "data-test": "highlight-button",
          variant: "tool",
          selected: isAnnotating && highlightSelected,
          disabled: disabled || isAnnotating && !highlightSelected,
          icon: /*#__PURE__*/_react.default.createElement(_Icon.default, null, _svgs.highlightIcon),
          onMouseDown: function onMouseDown(event) {
            return onAnnotationClick(event, 'highlight');
          }
        }) : /*#__PURE__*/_react.default.createElement(_TooltipButton.default, {
          "aria-label": _label,
          placement: "bottom",
          "data-annotation-button": true,
          "data-test": "highlight-button",
          selected: isAnnotating && highlightSelected,
          disabled: disabled || isAnnotating && !highlightSelected,
          icon: /*#__PURE__*/_react.default.createElement(_Icon.default, null, _svgs.highlightIcon),
          tooltip: _label,
          onClick: function onClick(event) {
            return onAnnotationClick(event, 'highlight');
          }
        })));
      }

      if (annotationTypes.strikethrough === true) {
        var strikethroughSelected = newAnnotationType === 'strikethrough';

        var _label2 = intl.formatMessage({
          id: 'comments.textarea_input.strikethrough.tooltip'
        });

        icons.push( /*#__PURE__*/_react.default.createElement("div", {
          className: "annotation-tool-wrapper",
          key: "strikethrough-tool"
        }, touchControls ? /*#__PURE__*/_react.default.createElement(_Button.default, {
          "aria-label": _label2,
          "data-annotation-button": true,
          "data-test": "strikethrough-button",
          variant: "tool",
          selected: isAnnotating && strikethroughSelected,
          disabled: disabled || isAnnotating && !strikethroughSelected,
          icon: /*#__PURE__*/_react.default.createElement(_TextStrikethrough.default, null),
          onMouseDown: function onMouseDown(event) {
            return onAnnotationClick(event, 'strikethrough');
          }
        }) : /*#__PURE__*/_react.default.createElement(_TooltipButton.default, {
          "aria-label": _label2,
          placement: "bottom",
          "data-annotation-button": true,
          "data-test": "strikethrough-button",
          selected: isAnnotating && strikethroughSelected,
          disabled: disabled || isAnnotating && !strikethroughSelected,
          icon: /*#__PURE__*/_react.default.createElement(_TextStrikethrough.default, null),
          tooltip: _label2,
          onClick: function onClick(event) {
            return onAnnotationClick(event, 'strikethrough');
          }
        })));
      }

      if (annotationTypes.insert === true) {
        var insertSelected = newAnnotationType === 'insert';

        var _label3 = intl.formatMessage({
          id: 'comments.textarea_input.insert.tooltip'
        });

        icons.push( /*#__PURE__*/_react.default.createElement("div", {
          className: "annotation-tool-wrapper",
          key: "insert-tool"
        }, touchControls ? /*#__PURE__*/_react.default.createElement(_Button.default, {
          "aria-label": _label3,
          "data-annotation-button": true,
          "data-test": "insert-button",
          variant: "tool",
          selected: isAnnotating && insertSelected,
          disabled: disabled || isAnnotating && !insertSelected,
          icon: /*#__PURE__*/_react.default.createElement(_Icon.default, null, _svgs.insertIcon),
          onMouseDown: function onMouseDown(event) {
            return onAnnotationClick(event, 'insert');
          }
        }) : /*#__PURE__*/_react.default.createElement(_TooltipButton.default, {
          "aria-label": _label3,
          placement: "bottom",
          "data-annotation-button": true,
          "data-test": "insert-button",
          selected: isAnnotating && insertSelected,
          disabled: disabled || isAnnotating && !insertSelected,
          icon: /*#__PURE__*/_react.default.createElement(_Icon.default, null, _svgs.insertIcon),
          tooltip: _label3,
          onClick: function onClick(event) {
            return onAnnotationClick(event, 'insert');
          }
        })));
      }

      if (annotationTypes.replace === true) {
        var replaceSelected = newAnnotationType === 'replace';

        var _label4 = intl.formatMessage({
          id: 'comments.textarea_input.replace.tooltip'
        });

        icons.push( /*#__PURE__*/_react.default.createElement("div", {
          className: "annotation-tool-wrapper",
          key: "replace-tool"
        }, touchControls ? /*#__PURE__*/_react.default.createElement(_Button.default, {
          "aria-label": _label4,
          "data-annotation-button": true,
          "data-test": "replace-button",
          variant: "tool",
          selected: isAnnotating && replaceSelected,
          disabled: disabled || isAnnotating && !replaceSelected,
          icon: /*#__PURE__*/_react.default.createElement(_Icon.default, null, _svgs.replaceIcon),
          onMouseDown: function onMouseDown(event) {
            return onAnnotationClick(event, 'replace');
          }
        }) : /*#__PURE__*/_react.default.createElement(_TooltipButton.default, {
          "aria-label": _label4,
          placement: "bottom",
          "data-annotation-button": true,
          "data-test": "replace-button",
          selected: isAnnotating && replaceSelected,
          disabled: disabled || isAnnotating && !replaceSelected,
          icon: /*#__PURE__*/_react.default.createElement(_Icon.default, null, _svgs.replaceIcon),
          tooltip: _label4,
          onClick: function onClick(event) {
            return onAnnotationClick(event, 'replace');
          }
        })));
      }

      if (annotationTypes.draw === true) {
        var drawSelected = newAnnotationType === 'draw';

        var _label5 = intl.formatMessage({
          id: 'comments.textarea_input.draw.tooltip'
        });

        icons.push( /*#__PURE__*/_react.default.createElement("div", {
          className: "annotation-tool-wrapper",
          key: "draw-tool"
        }, touchControls ? /*#__PURE__*/_react.default.createElement(_Button.default, {
          "aria-label": _label5,
          "data-annotation-button": true,
          "data-test": "draw-button",
          variant: "tool",
          selected: isAnnotating && drawSelected,
          disabled: disabled || isAnnotating && !drawSelected,
          icon: /*#__PURE__*/_react.default.createElement(_Draw.default, null),
          onMouseDown: function onMouseDown(event) {
            return onAnnotationClick(event, 'draw');
          }
        }) : /*#__PURE__*/_react.default.createElement(_TooltipButton.default, {
          "aria-label": _label5,
          placement: "bottom",
          "data-annotation-button": true,
          "data-test": "draw-button",
          selected: isAnnotating && drawSelected,
          disabled: disabled || isAnnotating && !drawSelected,
          icon: /*#__PURE__*/_react.default.createElement(_Draw.default, null),
          tooltip: _label5,
          onClick: function onClick(event) {
            return onAnnotationClick(event, 'draw');
          }
        })));
      }

      icons.push( /*#__PURE__*/_react.default.createElement("div", {
        className: "annotation-tool-wrapper",
        key: "color-tool"
      }, isAnnotating ? /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
        ref: this.handleOverlayTriggerRef,
        placement: "bottom",
        trigger: "click",
        crossOffset: overlayOffset || undefined,
        onShow: this.handleOverlayShow
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        "aria-label": intl.formatMessage({
          id: 'comments.arialabel.button.colorPicker'
        }),
        variant: "tool"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "annotation-color-display",
        style: {
          backgroundColor: annotationColor
        }
      })), /*#__PURE__*/_react.default.createElement(_Popover.default, {
        className: _AnnotationToolbar.default.popover
      }, _constants.ANNOTATION_COLOR_PALETE.map(function (_ref) {
        var hex = _ref.hex,
            name = _ref.name;
        return /*#__PURE__*/_react.default.createElement("button", {
          key: "color-".concat(hex),
          "aria-label": intl.formatMessage({
            id: "comments.colorPicker.colors.".concat(name)
          }),
          className: "annotation-color-option",
          style: {
            backgroundColor: hex
          },
          onClick: function onClick() {
            return _this3.handleColorSelection(hex);
          }
        });
      }))) : null));
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _AnnotationToolbar.default.component,
        ref: this.handleComponentRef
      }, icons);
    }
  }]);

  return AnnotationToolbar;
}(_react.default.Component);

exports.PureAnnotationToolbar = AnnotationToolbar;
AnnotationToolbar.propTypes = {
  annotationColor: _propTypes.default.string,
  annotationTypes: _propTypes.default.shape({
    draw: _propTypes.default.bool,
    highlight: _propTypes.default.bool,
    insert: _propTypes.default.bool,
    pin: _propTypes.default.bool,
    replace: _propTypes.default.bool,
    strikethrough: _propTypes.default.bool,
    text: _propTypes.default.bool
  }),
  disabled: _propTypes.default.bool,
  intl: _propTypes.default.object.isRequired,
  isAnnotating: _propTypes.default.bool,
  onAnnotationClick: _propTypes.default.func,
  touchControls: _propTypes.default.bool,
  newAnnotationType: _propTypes.default.string,
  saveAnnotationColor: _propTypes.default.func,
  compactLayout: _propTypes.default.bool
};

var _default = (0, _reactIntl.injectIntl)(AnnotationToolbar);

exports.default = _default;